export const login = () => '/login';
export const logout = () => '/logout';

export const editAccount = () => '/account/edit';
export const createAccount = () => '/register';
export const accountRetrieve = () => '/account/retrieve';
//
// Interface to modules paths
//
export * from './mobilizations/paths';
export * from './mobilizations/widgets/paths';
export * from './mobilizations/blocks/paths';
export * from './mobilizations/templates/paths';
export * from './community/paths';
